export default __webpack_public_path__ + "static/logo-bf5cd5ba762f6a318acc23eae1f33562.svg";